import { Link, useLocation } from "react-router-dom";
import { Phone, LayoutDashboard } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const Logo = ({ light = false }) => (
  <Link to="/" className="flex items-center">
    <img
      src="/logo-hostprotect.png"
      alt="HostProtect"
      className={light ? "h-9 w-auto brightness-0 invert" : "h-9 w-auto"}
    />
  </Link>
);

export { Logo };

export const MarketingHeader = ({ nav, showLangSwitcher = false, phone, phoneDisplay }) => {
  const location = useLocation();
  const { user } = useAuth();
  const dashboardPath = user && user.role === "admin" ? "/admin" : "/dashboard";

  return (
    <header
      className="backdrop-blur-xl bg-white/90 border-b border-neutral-200/50 sticky top-0 z-50"
      data-testid="marketing-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        <div className="flex justify-between items-center h-16">
          <Logo />

          <div className="flex items-center gap-2 md:gap-4">
            {showLangSwitcher && nav.langSwitcher?.length > 0 && (
              <div className="hidden sm:flex items-center gap-0.5 border border-neutral-200 rounded-full px-1 py-0.5">
                {nav.langSwitcher.map((lang) => (
                  <Link
                    key={lang.code}
                    to={lang.path}
                    className={`text-[11px] font-semibold px-2.5 py-1 rounded-full transition-colors ${
                      location.pathname === lang.path
                        ? "bg-[#19294C] text-white"
                        : "text-neutral-500 hover:text-[#19294C]"
                    }`}
                    data-testid={`lang-switch-${lang.code}`}
                  >
                    {lang.label}
                  </Link>
                ))}
              </div>
            )}

            {phone && (
              <a
                href={`tel:${phone}`}
                className="inline-flex items-center gap-1.5 text-sm text-[#19294C] font-medium hover:text-[#00B8E4] transition-colors"
                aria-label={`Appelez-nous au ${phoneDisplay}`}
                data-testid="header-phone-btn"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden md:inline">{phoneDisplay}</span>
              </a>
            )}

            {user ? (
              <Link
                to={dashboardPath}
                className="inline-flex items-center gap-1.5 text-sm text-[#19294C] font-medium hover:text-[#00B8E4] transition-colors"
                data-testid="header-dashboard-btn"
              >
                <LayoutDashboard className="w-3.5 h-3.5" />
                <span className="hidden sm:inline">Tableau de bord</span>
                <span className="sm:hidden">Dashboard</span>
              </Link>
            ) : (
              <>
                <Link
                  to="/connexion"
                  className="text-sm text-neutral-600 hover:text-[#19294C] transition-colors font-medium"
                  data-testid="header-login-btn"
                >
                  {nav.login}
                </Link>

                <Link to="/inscription">
                  <button
                    className="bg-[#00B8E4] text-white text-xs sm:text-sm px-3 sm:px-5 py-2 sm:py-2.5 rounded-full hover:bg-[#00a5ce] transition-colors font-semibold shadow-sm whitespace-nowrap"
                    data-testid="header-cta-btn"
                  >
                    {nav.cta}
                  </button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
